import { computed } from "vue";

export const useScatterChartOptions = ({
  baseOptions,
  textColor,
  gridColor,
  labelColor,
  xAxisLabel,
  yAxisLabel,
}) => {
  return computed(() => ({
    ...baseOptions.value,
    dataLabels: { enabled: false },
    xaxis: {
      type: "numeric",
      title: {
        text: xAxisLabel.value,
        style: {
          color: labelColor,
          fontSize: "12px",
          fontFamily: "Proxima Nova, sans-serif",
          fontWeight: 500,
          cssClass: "primary_color",
        },
      },
      labels: { style: { colors: textColor, fontSize: "11px" } },
      axisBorder: { show: true, color: gridColor },
      axisTicks: { show: false },
    },
    yaxis: {
      title: {
        text: yAxisLabel.value,
        style: {
          color: labelColor,
          fontSize: "12px",
          fontFamily: "Proxima Nova, sans-serif",
          fontWeight: 500,
          cssClass: "primary_color",
        },
      },
      labels: { style: { colors: textColor, fontSize: "11px" } },
    },
    markers: { size: 6 },
  }));
};

